import moment from 'utils/moment';
import { getFileSize } from '../../../../utils/format';
import { CARD_STATUS } from '../../constants';

const DATE_FORMAT = 'DD.MM.YYYY';

/**
 * Create file status description based on gourp attachment status
 * @param {Number} status
 */
const createDescription = (status) => {
  switch (status) {
    case CARD_STATUS.CREATED:
    case CARD_STATUS.SENT:
      return 'Документ направлен в налоговый орган';
    case CARD_STATUS.RECEIVED:
      return 'Документ получен налоговым органом';
    case CARD_STATUS.REGISTERED:
      return 'Документ зарегистрирован налоговым органом';
    case CARD_STATUS.REJECTED:
      return 'Документ отклонен налоговым органом';
    case CARD_STATUS.ERROR:
      return 'Ошибка получения документа. Повторите отправку или обратитесь в службу поддержки';
    default:
      return '';
  }
};

const getXMLDescription = {
  [CARD_STATUS.DRAFT]: 'Заполнение декларации не завершено',
  [CARD_STATUS.SENT]: 'Декларация отправлена',
  [CARD_STATUS.RECEIVED]: 'Декларация получена',
  [CARD_STATUS.ERROR]: 'Ошибка получения декларации',
  [CARD_STATUS.REGISTERED]: 'Декларация зарегистрирована',
  [CARD_STATUS.REJECTED]: 'Декларация отклонена',
  [CARD_STATUS.ANSWER_IS_GET]: 'Получен ответ',
  [CARD_STATUS.ASSIGNED_TO_SP]: 'Назначено на СП',
  [CARD_STATUS.ON_EXECUTION]: 'На исполнении',
  [CARD_STATUS.EXECUTED]: 'Исполнено',
  [CARD_STATUS.CREATED]: 'Декларация отправлена',
  [CARD_STATUS.INJECTED]: 'Декларация зарегистрирована',
  [CARD_STATUS.ON_CLARIFICATION]: 'Необходимо уточнение декларации',
};

/**
 * Process file to make it readable

 * @param {Object} file
 */
const processFile = (file) => {
  file.sentDate = moment(file.sentDate).format(DATE_FORMAT);
  file.size = getFileSize(file.size).label;

  // файл xml
  if (file.attachmentType === 3) {
    file.statusDescription = getXMLDescription[file.cardStatus];
  } else {
    file.statusDescription = createDescription(file.cardStatus);
  }
};

/**
 * Process received data

 * @param {Array} data
 */
const processData = (data) => {
  const processedData = { ...data };

  processedData.files.map((fileItem) => {
    return processFile(fileItem);
  });

  return processedData;
};

export default processData;
